import React from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import MDefaultform from '../m_defaultForm'
import { checkRequireLabel } from '../../../../../../utils/form/checkRequireLabel'
import { extractFields } from '../../../../../../utils/form/extractFields'
import { emailRegex } from '../../../../../../utils/form/emailRegex'

const MSalesRequestForm = ({ data }) => {
  const t = useTranslations()

  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)

  return (
    <MDefaultform
      buttonLabel="Anfrage senden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      formType={formType}
      ShouldPersist={true}
    >
      {({ register, errors }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}
          {data.text && <DfbRte text={data.text} add_class="m-Formblock-text" />}
          {(fields.firstname || fields.lastname || fields.email) && (
            <div className="m-Formblock-row-third">
              {[fields.firstname, fields.lastname].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-row-third-cell" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={checkRequireLabel(formItem)}
                    focused
                  />
                </div>
              ))}
              <div className="m-Formblock-row-third-cell">
                <DfbInput
                  {...register(fields.email.identifier, {
                    required: fields.email.required ? t('form.errorMessage.input') : false,
                    pattern: {
                      value: emailRegex,
                      message: t('form.errorMessage.emailPattern'),
                    },
                  })}
                  error={errors[fields.email.identifier]}
                  errorMessage={errors?.[fields.email.identifier]?.message}
                  label={checkRequireLabel(fields.email)}
                  focused
                />
              </div>
            </div>
          )}

          {fields.privacy && (
            <div className="m-Formblock-input">
              <DfbParagraph text={t('form.privacyText')} add_class="m-Formblock-text" />
            </div>
          )}
        </>
      )}
    </MDefaultform>
  )
}

export default MSalesRequestForm
